<mat-dialog-content class="dialog-text">
  @switch (currentStep) {
    @case (1) {
      <app-provider-selection [isModal]="true" (providerUserIdSelected)="onSelection($event)"></app-provider-selection>
    }
    @case (2) {
      <app-visit-type-selection
        [providerUserId]="providerUserId!"
        [isModal]="true"
        (visitTypeSelected)="onSelection($event.value, $event.isVirtualVisitType)"></app-visit-type-selection>
    }
    @case (3) {
      <app-provider-location-selection
        [providerUserId]="providerUserId!"
        [visitTypeId]="visitTypeId!"
        [isModal]="true"
        (teamIdSelected)="onSelection($event)"></app-provider-location-selection>
    }
    @case (4) {
      <app-appointment-selection
        [providerUserId]="providerUserId!"
        [visitTypeId]="visitTypeId!"
        [teamId]="teamId"
        [isModal]="true"
        [patientId]="patientId$ | async"></app-appointment-selection>
    }
    @case (5) {
      <app-confirm-appointment [showSave]="false" confirmationType="appointment"></app-confirm-appointment>
    }
  }
</mat-dialog-content>
<mat-dialog-actions align="end">
  @if (showBackButton) {
    <button mat-stroked-button id="backBtn" class="secondary-btn" (click)="goBack()">Back</button>
  }
  @if (currentStep !== 5) {
    <button mat-stroked-button id="cancelBtn" class="error-btn" (click)="cancel()">Cancel</button>
  }
  @if (action) {
    <button mat-flat-button id="primaryBtn" class="primary-btn" cdkFocusInitial (click)="action()">
      {{ primaryButtonText }}
    </button>
  }
</mat-dialog-actions>
